/**
 * Een icoon dat je kunt aanklikken — als échte knop.
 *
 * In deze codebase stond dit overal als `<img onClick>` met de betekenis in een
 * hover-tooltip. Dat is twee keer stuk: een `<img>` staat niet in de
 * tabvolgorde, en `common/Tooltip` kent alleen muis-handlers, dus voor een
 * schermlezer of op een aanraakscherm had de knop geen naam.
 *
 * Het icoon zelf is decoratief (`alt=""` + `aria-hidden`); de knop draagt de
 * naam. Zet deze component ín de Tooltip, niet eromheen, zodat de tooltip blijft
 * werken voor wie een muis gebruikt.
 *
 * De opmaak komt van de klasse `icon-button` in CSS/layout/layout.css: die zet
 * de globale `button`-regel terug, anders wordt elk icoon een turkooizen pil.
 * AI-CONTEXT: See docs/pitfalls.md#ui-hover-only-affordance-dies-on-mobile
 * AI-CONTEXT: See docs/pitfalls.md#ui-scoped-rule-lands-on-a-global-element-rule
 *
 * @param {object} props
 * @param {string} props.icon - Bronpad van het icoon (een geïmporteerde afbeelding)
 * @param {string} props.label - Wat de knop doet; de toegankelijke naam. Meestal dezelfde tekst als de tooltip
 * @param {() => void} props.onClick - Aangeroepen bij klik of toetsenbordbediening
 * @param {string} [props.className] - Extra klasse op de knop
 * @param {string} [props.imgClassName] - Extra klasse op het icoon, voor bestaande maat-CSS
 */
const IconButton = ({ icon, label, onClick, className = '', imgClassName = '' }) => (
    <button
        type='button'
        className={`icon-button ${className}`.trim()}
        aria-label={label}
        onClick={onClick}
    >
        <img src={icon} alt='' aria-hidden='true' className={imgClassName || undefined} />
    </button>
);

export default IconButton;
